/**
 * Voice notes must play on the phones too, and iOS has no WebM/Opus decoder.
 * The recorder asks the browser for MP4/AAC first; a browser that only
 * records WebM/Ogg (Firefox, older Chrome) gets its note re-encoded to M4A/AAC
 * here with the browser's own encoder (WebCodecs, via mediabunny — loaded only
 * when needed). If even that isn't available, the original goes as is.
 */

/** Formats the chat asks the recorder for, best first. */
export const VOICE_PREFERRED_MIME_TYPES = [
  "audio/mp4;codecs=mp4a.40.2",
  "audio/mp4",
  "audio/aac",
];

export const isMp4Audio = (type: string) => /audio\/(mp4|aac|x-m4a)/i.test(type);

export const toM4a = async (blob: Blob): Promise<Blob> => {
  if (isMp4Audio(blob.type)) return blob;
  try {
    const { ALL_FORMATS, BlobSource, BufferTarget, Conversion, Input, Mp4OutputFormat, Output } =
      await import("mediabunny");
    const output = new Output({
      format: new Mp4OutputFormat({ fastStart: "in-memory" }),
      target: new BufferTarget(),
    });
    const conversion = await Conversion.init({
      input: new Input({ formats: ALL_FORMATS, source: new BlobSource(blob) }),
      output,
      video: { discard: true },
      audio: { codec: "aac", bitrate: 64_000 },
    });
    if (!conversion.isValid) return blob;
    await conversion.execute();
    const buffer = output.target.buffer;
    return buffer ? new Blob([buffer], { type: "audio/mp4" }) : blob;
  } catch {
    return blob;
  }
};
